import { useApiClient, useFetch } from '@marageti/z4-lib';
import { FilterOp, SearchResult } from '@marageti/z4-sdk/lib/entity';
import { Ticket } from '@marageti/z4-sdk/lib/tickets';

const useTravelerTicketsCount = (travelerId?: string) => {
  const apiClient = useApiClient();

  const { data, isLoading, mutate } = useFetch<SearchResult<Ticket>>(
    apiClient.ticketsClient.searchTickets,
    [{
      filterBy: [
        { field: 'ticketType', op: FilterOp.FilterOpTerm, value: ['ISSUE'] },
        { field: 'status', op: FilterOp.FilterOpNot, value: ['CANCELED'] },
        { field: 'travelerId', op: FilterOp.FilterOpTerm, value: [travelerId || ''] },
      ],
      pagination: { limit: 0, page: 1 },
    }],
    !!travelerId,
  );

  return { ticketCount: data?.totalHits, isLoading, mutate };
};

export default useTravelerTicketsCount;
